/* eslint-disable */
export default {
  header: '联系支持人员',
  toggleTitle: '1. 开启错误跟踪模式',
  toggleDescription: '这有助于我们定位问题，但可能会对应用性能产生些许影响。',
  downloadTitle: '2. 问题复现时，下载错误日志。',
  downloadButton: '下载',
  downloadDisabledTitle: '请先开启错误跟踪模式，然后才能下载错误日志。',
  sendTitle: '3. 将日志发送给支持团队',
  createSupportTicket: '创建支持请求',
  sendDescription:
    ' 联系我们的支持团队。然后将日志发送给支持团队进行故障排查。',
  privacyNotice:
    '下载日志并发送给我们，即表示您同意 RingCentral 访问某些日志相关信息，以便进行故障排查和错误处理。有关 RingCentral 如何处理个人数据的更多信息，请查看我们的 ',
  privacyNoticeLink: '服务条款',
  and: ' 和 ',
  privacyNoticeEnd: '隐私声明。',
  needLeavePage:
    '错误跟踪运行期间，您可以暂时离开此页面。复现问题后，请返回此页面下载日志文件。',
  downloading: '正在下载',
} as const;

// @key: @#@"header"@#@ @source: @#@"Contact support"@#@
// @key: @#@"toggleTitle"@#@ @source: @#@"1. Turn on error tracking mode"@#@
// @key: @#@"toggleDescription"@#@ @source: @#@"This will help us locate your issues, but may slightly affect your app performance."@#@
// @key: @#@"downloadTitle"@#@ @source: @#@"2. Download the error log when you have replicated the issue."@#@
// @key: @#@"downloadButton"@#@ @source: @#@"Download"@#@
// @key: @#@"downloadDisabledTitle"@#@ @source: @#@"Turn on error tracking mode before you can download error log."@#@
// @key: @#@"sendTitle"@#@ @source: @#@"3. Send the log to support team"@#@
// @key: @#@"createSupportTicket"@#@ @source: @#@"Create a support ticket"@#@
// @key: @#@"sendDescription"@#@ @source: @#@" to get in touch with our support team. Then send the log to the support team for troubleshooting."@#@
// @key: @#@"privacyNotice"@#@ @source: @#@"By downloading and sending us the log, you agree to allow RingCentral to access certain log related information for troubleshooting and error handling purposes. For more information on how RingCentral processes personal data, please review our "@#@
// @key: @#@"privacyNoticeLink"@#@ @source: @#@"Terms of Service"@#@
// @key: @#@"and"@#@ @source: @#@" and "@#@
// @key: @#@"privacyNoticeEnd"@#@ @source: @#@"Privacy Notice."@#@
// @key: @#@"needLeavePage"@#@ @source: @#@"You may leave this page while error tracking is running. When you have replicated the issue, return to this page and download the log files."@#@
// @key: @#@"downloading"@#@ @source: @#@"Downloading"@#@
